<template>
  <div class="participant-main-menu" :class="[`is-${gender}`]">

    <div class="participant-main-menu__content">

      <instance-profile-card
         theme="participant-area"
         mode="participant-area"
        :mask-shade="false"
        :InstanceInfo="InstanceInfo"
        :PersonalProfile="PersonalProfile">
      </instance-profile-card>

      <div class="content__menu-list">
        <nuttrema-menu-list theme="popover-nav" class="is-user-menu is-white" :class="[`is-${gender}`]">
          <template slot="vertical-top">

            <!-- <nuttrema-menu-list-item>
              <p class="list-item-label">{{ $t('label.quick_links') }}</p>
            </nuttrema-menu-list-item> -->

            <section>
              <template v-if="logged">
                <nuttrema-menu-list-item>
                  <a class="list-item-link"
                    :class="{ 'is-active': isActive('participant-area-schedules') }"
                    @click="routerLink('participant-area-schedules')">
                    <span>{{ $t('label.my_schedules') }}</span>
                  </a>
                </nuttrema-menu-list-item>

                <nuttrema-menu-list-item>
                   <div class="list-item-link"
                     v-if="isSection('my-preferences')"
                    :class="{ 'is-active': isSection('my-preferences') }">
                    <span>{{ $t('label.my_preferences') }}</span>
                    <nuttrema-menu-list theme="popover-nav" class="is-user-menu">

                      <nuttrema-menu-list-item>
                        <a class="list-item-link"
                        :class="{ 'is-active': isActive('participant-area-my-preferences') }"
                        @click="routerLink('participant-area-my-preferences')">
                          <span>{{ $t('label.main_details') }}</span>
                        </a>
                      </nuttrema-menu-list-item>

                      <nuttrema-menu-list-item>
                        <a class="list-item-link"
                          :class="{ 'is-active': isActive('participant-area-profile-picture') }"
                          @click="routerLink('participant-area-profile-picture')">
                          <span>{{ $t('label.profile_picture') }}</span>
                        </a>
                      </nuttrema-menu-list-item>

                      <nuttrema-menu-list-item>
                        <a class="list-item-link"
                          :class="{ 'is-active': isActive('participant-area-change-email') }"
                          @click="routerLink('participant-area-change-email')">
                          <span>{{ $t('label.change_email') }}</span>
                        </a>
                      </nuttrema-menu-list-item>

                      <nuttrema-menu-list-item>
                        <a class="list-item-link"
                          :class="{ 'is-active': isActive('participant-area-change-password') }"
                          @click="routerLink('participant-area-change-password')">
                          <span>{{ $t('label.change_password') }}</span>
                        </a>
                      </nuttrema-menu-list-item>

                      <nuttrema-menu-list-item>
                        <a class="list-item-link"
                          :class="{ 'is-active': isActive('participant-area-deactivate-account') }"
                          @click="routerLink('participant-area-deactivate-account')">
                          <span>{{ $t('label.deactivate_account') }}</span>
                        </a>
                      </nuttrema-menu-list-item>
                    </nuttrema-menu-list>
                   </div>

                   <a class="list-item-link"
                     v-else
                    :class="{ 'is-active': isActive('participant-area-my-preferences') }"
                    @click="routerLink('participant-area-my-preferences')">
                    <span>{{ $t('label.my_preferences') }}</span>
                  </a>
                </nuttrema-menu-list-item>
              </template>
              <!-- end ~ logged -->

              <template v-else>
                <nuttrema-menu-list-item v-if="isActive('participant-area-public-schedules')">
                  <a class="list-item-link"
                    :class="{ 'is-active': isActive('participant-area-public-schedules') }"
                    @click="routerLink('participant-area-public-schedules')">
                    <span>{{ $t('label.my_schedules') }}</span>
                  </a>
                </nuttrema-menu-list-item>

                <nuttrema-menu-list-item v-if="isActive('participant-area-forgot-password')">
                  <a class="list-item-link"
                    :class="{ 'is-active': isActive('participant-area-forgot-password') }"
                    @click="routerLink('participant-area-forgot-password')">
                    <span>{{ $t('label.forgot_password') }}</span>
                  </a>
                </nuttrema-menu-list-item>

                <nuttrema-menu-list-item v-if="isActive('participant-area-reset-password')">
                  <a class="list-item-link"
                    :class="{ 'is-active': isActive('participant-area-reset-password') }"
                    @click="routerLink('participant-area-reset-password')">
                    <span>{{ $t('label.reset_password') }}</span>
                  </a>
                </nuttrema-menu-list-item>

                <nuttrema-menu-list-item v-if="isActive('participant-area-join-instance')">
                  <a class="list-item-link"
                    :class="{ 'is-active': isActive('participant-area-join-instance') }"
                    @click="routerLink('participant-area-join-instance')">
                    <span>{{ $t('label.join_instance') }}</span>
                  </a>
                </nuttrema-menu-list-item>

                <nuttrema-menu-list-item v-if="isActive('participant-area-activate-account')">
                  <a class="list-item-link"
                    :class="{ 'is-active': isActive('participant-area-activate-account') }"
                    @click="routerLink('participant-area-activate-account')">
                    <span>{{ $t('label.activate_account') }}</span>
                  </a>
                </nuttrema-menu-list-item>
              </template>
              <!-- end ~ section if not logged -->

              <!-- show in any case if it's active -->
              <nuttrema-menu-list-item v-if="isActive('participant-area-verify-email')">
                <a class="list-item-link"
                  :class="{ 'is-active': isActive('participant-area-verify-email') }"
                  @click="routerLink('participant-area-verify-email')">
                  <span>{{ $t('label.verify_email') }}</span>
                </a>
              </nuttrema-menu-list-item>

            </section>

          </template>
        </nuttrema-menu-list>
      </div>

    </div>

    <div class="participant-main-menu__footer">
      <router-link
         v-if="logged"
         class="el-button el-button--nuttrema-outer-white w-100 is-more-round"
        :to="{ name: 'participant-area-logout' }">
        {{ $t('label.logout') }}
      </router-link>

      <router-link
         v-else
         activeClass="is-selected"
         class="el-button el-button--nuttrema-outer-white w-100 is-more-round"
        :to="{ name: 'participant-area-login' }">
        {{ $t('label.login') }}
      </router-link>

      <div class="footer__logo">
        <img src="~/assets/images/dc-logo-powered-by-dc-white.svg" :alt="$t('label.diet_creator_logo_alt')">
      </div>
    </div>
  </div>
</template>

<script>
import { get, isEmpty } from 'lodash';

import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';

import InstanceProfileCard from 'components/ui/card/instance-profile-card';

export default {
  name: 'participant-main-menu',
  props: {
    InstanceInfo: {
      required: false,
      default: null,
    },
    PersonalProfile: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaMenuList,
    InstanceProfileCard,
    NuttremaMenuListItem,
  },
  data() {
    return {
      isHeaderVisible: true,
    };
  },
  computed: {
    gender() {
      return get(this.PersonalProfile, 'data.gender') || 'male';
    },
    logged() {
      const user = this.$auth.user();
      return isEmpty(user) ? false : user;
    },
  },
  methods: {
    routerLink(name) {
      this.$emit('close');
      this.$router.push({ name });
    },
    close() {
      this.$emit('close');
    },
    logout() {
      this.$auth.logout();
      this.$router.push({ name: 'participant-area-login' });
    },
    isActive(name) {
      const current = get(this.$route, 'name', false);
      return current && current === name;
    },
    isSection(name) {
      const current = get(this.$route, 'meta.section', false);
      return current && current === name;
    },
    visibilityChanged(isVisible) {
      this.isHeaderVisible = isVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/theme/colors";
@import "~styles/theme/person-colors";
@import '~styles/mixins/mixins';
@import '~styles/mixins/gradients';

$background-color: #f6f8fb;
$header-color: rgba(0,0,0, 0.15);

.participant-main-menu {
  flex-grow: 1;
  display: flex;
  align-self: stretch;
  flex-direction: column;
  justify-content: space-between;

  height: 100vh;
  flex-shrink: 0;
  overflow: hidden;

  .participant-main-menu__header {
    z-index: 2;
    display: flex;
    flex-direction: column;
    position: absolute;
    align-self: stretch;
    transition: all 0.3s;
    flex-direction: column;
    margin: 0.5em 0.5em 0 0.5em;
    justify-content: center;
    top: 0; left: 0; right: 0;

    .header__instance {
      display: flex;
      justify-content: center;
      border-top-left-radius: 0.5em;
      border-top-right-radius: 0.5em;
      background-color: rgba(0,0,0, 0.35);
      > span {
        color: #fff;
        font-weight: 400;
        font-size: 0.9rem;
      }
    }

    .header__powered-by {
      display: flex;
      padding: 0.35em 0;
      align-items: center;
      justify-content: center;
      // background-color: rgba(0,0,0, 0.15);
      > img {
        height: 1.5em;
      }
    }

  }

  .participant-main-menu__content {
    flex-grow: 1;
    display: flex;
    overflow-y: auto;
    align-self: stretch;
    flex-direction: column;
    margin: 0.5em 0em 4em 0;
    border-top-left-radius: 0.5em;
    border-top-right-radius: 0.5em;
  }

  .participant-main-menu__footer {
    display: flex;
    align-self: stretch;
    flex-direction: column;
    position: absolute;
    bottom: 0; left: 0; right: 0;
    margin: 0 0.75em 0.75em 0.75em;
    text-align: center;
    color: #fff;
    justify-content: center;

    .footer__logo {
      margin: 0.75em 0.25em 0 0;
      text-align: right;
      img {
        width: 55%;
      }
    }
  }

  &:after {
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    content: '';
    height: 100%;
    opacity: 0.05;
    position: absolute;
    background: transparent url('~assets/images/dc-logo-bg-gray.svg') no-repeat;
    background-position: bottom -1em right -2em;
    background-size: 21em;
  }

  .is-for-desktop &,
  .for-big-desktop & {
    min-width: 18em;
    max-width: 21em;
  }

  > * {
    z-index: 1;
  }

  .content__image-wrap {
    position: relative;
    text-align: center;
    margin-left: 0.5em;
    border-top-left-radius: 0.5em;
    border-top-right-radius: 0.5em;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    justify-content: center;

    svg {
      display: none;
    }

    .blur {
      transition: 1s;
      top: -5%; left: -5%;
      position: absolute;
      filter: url(#blur);
      filter: blur(7px);
      filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='7');
    }

    .full-picture {
      width: 110%;
      height: 110%;
      position: absolute;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }

    .image-circle {
      z-index: 1;
      width: 8em;
      height: 8em;
      margin-top: 4.5em;
      overflow: hidden;
      position: relative;
      border-radius: 50%;
      display: inline-block;
      border: 0.35em solid $background-color;
      background-color: $professional-leader;
       .image {
        width: 100%;
        height: 100%;
        top: 0; left: 0;
        position: absolute;
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: center center;
      }
      i {
        font-size: 5rem;
        line-height: 7rem;
        color: #fff;
      }
    }

    .background-mask {
      z-index: 0;
      height: 12em;
      top: 0; left: 0;
      overflow: hidden;
      position: absolute;
      width: 100%;
      // background: $turquoise;
      // border-top-left-radius: 0.25em;
      // border-top-right-radius: 0.25em;
      clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);
      -webkit-clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);

      @include gradient-vertical($professional-leader-dark, $professional-leader-light);
      // background-image: url('~assets/images/person-bg-turquoise.jpg');
      background-position: top center;
    }
  }
  // end ~ content__image-wrap

  .content__title {
    text-align: center;
    margin: 0.5em 0.75em;
    .content__title__name {
      font-weight: 800;
      font-size: 1.15em;
      color: #fff;
      text-shadow: 0 -1px 0 rgba(0,0,0, 0.25);
    }
    .content__title__email {
      color: #e6e6e6;
    }
  }

  .horizontal-divider {
    margin: 0.5em 0;
    color: #fff;
  }

  &.is-female {
    .background-mask {
      @include gradient-vertical($female-dark, $female-light);
      background-image: url(~assets/images/svg-shapes/shape-01-transparent-black-20.svg);
    }
    .image-circle {
      background-color: $female;
    }
  }

  &.is-male {
    .background-mask {
      @include gradient-vertical($male-dark, $male-light);
      background-image: url(~assets/images/svg-shapes/shape-01-transparent-black-20.svg);
      background-position: center center;
    }
    .image-circle {
      background-color: $male;
    }
  }

  .is-for-desktop &, .is-for-big-desktop & {
    min-width: 18em;

    .participant-main-menu__header {
      margin: 0.5em 0.5em 0 0.5em;
    }

    .participant-main-menu__content {
      margin: 0.5em 0 0.5em 0;
    }

    .content__image-wrap {
      margin-right: 0.5em;
      .image-circle {
        width: 10em;
        height: 10em;
        border: 0.5em solid $background-color;
      }
      i {
        font-size: 7rem;
        line-height: 8.5rem;
      }
    }

    .participant-main-menu__footer {
      margin: 0 0.5em 0.5em 0.5em;
      .footer__logo {
        margin: 0.75em 0.25em 0 0;
        text-align: right;
        img {
          width: 55%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/menu/participant/participant-main-menu.vue